import { serviceRequest } from 'utils/http';
import { SendInvitationLinkDto, SiteEmployeeService } from 'common/api';

export function sendInvitationLinkEmailAPI(requestBody: SendInvitationLinkDto) {
  return serviceRequest(() =>
    SiteEmployeeService.siteEmployeeControllerSendInvitationLinkEmail(
      requestBody
    )
  );
}
